// * Master File for site JS * //


//Import Init function 
import initJS from './init';
initJS();

//Import Barba seperately
//import './functions/init-barba';


document.querySelector('body').classList.remove('no-js');
document.querySelector('#js__body').classList.remove('no-js');


// import Swiper styles
import '../../../node_modules/swiper/swiper.scss';

// // Import main scss file here. This will compile to a css file in the dist folder
import '../sass/style.scss';